<template>
  <div class="serve">
    <!-- <div class="ceshi">
      <z-select
      :option='msgs'
      indexs='ids'
      values='value1'
      v-model="test1" 
      @ChangeOk='names'/>
    </div>
    <div class="ceshi">
      <z-select
      :option='msgs'
      indexs='ids'
      values='value1'
      v-model="test2" 
      @ChangeOk='names'/>
    </div> -->
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide v-for="(i,index) in bannerImg" :key='index'>
          <img :src="i" class="swiperImg">
      </swiper-slide>
    </swiper>
    

    <div class="clientCon2" id="clientCon2" style="margin-top:80px;margin-bottom:80px;" data-aos=""  data-aos-duration="1200">
      <div class="clientCon21 contentWidth">
        <div class="clientCon21_left">
          <!-- <div class="clientAbout" :style="'opacity:'+(Con3>=1?'1':'0')"> -->
          <div class="clientAbout" style="width:700px;">
            <span class="clientAbout_top">
              INTEGRATED ECOMMERCE OPERATION
            </span><br>
            <span class="clientAbout_bot">
              整合电商运营
            </span>
            <p></p>
          </div>
        </div>
      </div>
    </div>

    <div class="serveCon1" id="serveCon1">
      <!-- <div class="serveCon11 contentWidth">
        <div class="serveCon11_left">
          <img src="../../assets/img/serve/sb.png" alt="">
          <div class="serveAbout">
            <span class="serveAbout_top">
              FULL OPERATION
            </span><br>
            <span class="serveAbout_bot">
              电商高效运营
            </span>
          </div>
        </div>
        <div class="serveCon11_right">
          <span></span>
          <p>
            <span>数聚智连为品牌提供以营销驱动为导向的全方位电子商务解决方案，倡导高效整合型电商服务理念即（performance-marketing-driven E2E EC），通过高效营销（电商媒体，电商营销）和高效运营驱动品牌销售
            </span><br><br>
            <span>在电商运营服务上主要提供网络品牌定位、电商视觉、运营策划、数据服务、客户服务、会员管理、仓储物流等整体托管服务。凭借为数十家国内外知名企业/品牌提供个性化的电商服务经验，在消费电子、母婴、快速消费品/美妆、汽车等行业积累了自有服务理念。</span>
          </p>
        </div>
      </div> -->
    



      <div class="serveCon12 contentWidth">
        <div @mouseover='ImgMouse(0)' :style="'padding:'+(ImgHover==0?'30px 60px':'')" :class="'serveCon12To serveBotB'">
          <div :class="'serveBotJ '+(ImgHover==0?'serveBotJD':'')">
            <span></span>
            <span></span>
          </div>
          <h2>店铺运营</h2>
          <span>市场定位</span>
          <span>市场理解和规划</span>
          <span>视觉</span>
          <span>平台资源获取</span>
          <span>日常运营</span>
          <span>生意机会挖掘</span>
        </div>
        <div @mouseover='ImgMouse(1)' :style="'padding:'+(ImgHover==1?'30px 60px':'')" :class="'serveCon12To serveBotT'">
          <div :class="'serveBotJ '+(ImgHover==1?'serveBotJD':'')">
            <span></span>
            <span></span>
          </div>
          <h2>渠道分销</h2>
          <span>天猫、淘宝分销</span>
          <span>其他分销</span>
          <span>进销存管理和销售后台对接</span>
        </div>
        <div @mouseover='ImgMouse(2)' :style="'padding:'+(ImgHover==2?'30px 60px':'')" :class="'serveCon12To serveBotB'">
          <div :class="'serveBotJ '+(ImgHover==2?'serveBotJD':'')">
            <span></span>
            <span></span>
          </div>
          <h2>CRM</h2>
          <span>CRM平台搭建</span>
          <span>CRM建模</span>
          <span>用户招募</span>
          <span>忠诚管理</span>
          <span>会员营销</span>
        </div>
        <div @mouseover='ImgMouse(3)' :style="'padding:'+(ImgHover==3?'30px 60px':'')" :class="'serveCon12To serveBotT'">
          <div :class="'serveBotJ '+(ImgHover==3?'serveBotJD':'')">
            <span></span>
            <span></span>
          </div>
          <h2>客服</h2>
          <span>售前和售后客服</span>
          <span>QC质检</span>
          <span>跟单回访</span>
          <span>客服培训</span>
        </div>
        <div @mouseover='ImgMouse(4)' :style="'padding:'+(ImgHover==4?'30px 60px':'')" :class="'serveCon12To serveBotT'">
          <div :class="'serveBotJ '+(ImgHover==4?'serveBotJD':'')">
            <span></span>
            <span></span>
          </div>
          <h2>数据分析</h2>
          <span>数据挖掘</span>
          <span>品类数据分析</span>
          <span>店铺数据分析</span>
          <span>竞品分析</span>
          <span>第三方数据整合及分析</span>
        </div>
        <div @mouseover='ImgMouse(5)' :style="'padding:'+(ImgHover==5?'30px 60px':'')" :class="'serveCon12To serveBotB'">
          <div :class="'serveBotJ '+(ImgHover==5?'serveBotJD':'')">
            <span></span>
            <span></span>
          </div>
          <h2>仓储物流</h2>
          <span>仓储物流</span>
          <span>跨境仓储物流</span>
          <span>第三方仓储物流资源对接</span>
        </div>
        <div @mouseover='ImgMouse(6)' :style="'padding:'+(ImgHover==6?'30px 60px':'')" :class="'serveCon12To serveBotT'">
          <div :class="'serveBotJ '+(ImgHover==6?'serveBotJD':'')">
            <span></span>
            <span></span>
          </div>
          <h2>O2O</h2>
          <span>线下零售管理</span>
          <span>活动，会展的物料和搭建</span>
          <span>线下营销顾问管理</span>
        </div>
      </div>
    </div>
    <div class="serveCon2" id='serveCon2'>
      
      
    <div class="clientCon2" id="clientCon2" style="margin-top:80px;margin-bottom:80px;" data-aos=""  data-aos-duration="1200">
      <div class="clientCon21 contentWidth">
        <div class="clientCon21_left">
          <!-- <div class="clientAbout" :style="'opacity:'+(Con3>=1?'1':'0')"> -->
          <div class="clientAbout">
            <span class="clientAbout_top">
              BRAND MARKETING
            </span><br>
            <span class="clientAbout_bot1">
              品牌营销
            </span>
            <p></p>
          </div>
        </div>
      </div>
    </div>

      <!-- <div class="serveCon21 contentWidth" :style="'opacity:'+(Con2>=2?'1':'0')">
        <div class="serveCon21_left">
          <img src="../../assets/img/serve/sb.png" alt="">
          <div class="serveAbout">
            <span class="serveAbout_top">
              RETAIL BUSINESS
            </span><br>
            <span class="serveAbout_bot">
              品牌营销
            </span>
          </div>
        </div>
        <div class="serveCon21_right">
          <span></span>
          <p>
            <span>北京数聚智连从电商市场发展趋势、品牌需求、消费者需求角度出发为品牌提供以效果驱动销售为导向的整合营销服务。借助数聚智连自有的公共关系、社会化营销、数字营销、广告投放、创意等优势，通过自有的强大数据分析能力和品牌营销能力，为所服务的品牌规划实施基于终端销售结果的品牌曝光、消费者互动的全方位解决方案，最终以高效卖货能力的整合营销手段实现客户的品效双赢。</span>
          </p>
        </div>
      </div> -->
      
      <!-- <div class="serveCon22 contentWidth" v-if="Con2>=2">动效 -->
      <div class="serveCon22 contentWidth">
        <!-- <div class="serveCon22C" @mouseover='Retail(0)'  @mouseleave='RetailLe()' :style="'background:'+(RetailD==0?'#fff;box-shadow:0px 0px 10px #ccc;':'')"> -->
        <div class="serveCon22C" @mouseover='Retail(0)'  @mouseleave='RetailLe()'>
          <!-- <div class="server22T" :style="'height:'+(Con2>=5?'80%;':'0%;')"></div> -->
          <div class="server22T" style="height:80%;"></div>
          <h2>品牌咨询</h2>
          <span>品牌战略</span>
          <span>电商咨询</span>
          <span>品牌战略</span>
          <span>数据咨询</span>
        </div>
        <!-- <div class="serveCon22C" @mouseover='Retail(1)'  @mouseleave='RetailLe()' :style="'background:'+(RetailD==1?'#fff;box-shadow:0px 0px 10px #ccc;':'')"> -->
        <div class="serveCon22C" @mouseover='Retail(1)'  @mouseleave='RetailLe()'>
          <!-- <div class="server22B" :style="'height:'+(Con2>=5?'80%;':'0%;')"></div> -->
          <div class="server22B" style="height:80%;"></div>
          <h2>品牌营销</h2>
          <span>市场洞察与分析</span>
          <span>策略制定</span>
          <span>品牌公关</span>
          <span>数字创意</span>
          <span>资源整合</span>
          <span>媒介服务</span>
          <span>数据追踪与分析</span>
        </div>
        <!-- <div class="serveCon22C" @mouseover='Retail(2)'  @mouseleave='RetailLe()' :style="'background:'+(RetailD==2?'#fff;box-shadow:0px 0px 10px #ccc;':'')"> -->
        <div class="serveCon22C" @mouseover='Retail(2)'  @mouseleave='RetailLe()'>
          <!-- <div class="server22T" :style="'height:'+(Con2>=5?'80%;':'0%;')"></div> -->
          <div class="server22T" style="height:80%;"></div>
          <h2>效果营销</h2>
          <span>电商营销</span>
          <span>站内内容</span>
          <span>数字创意</span>
          <span>电商媒体</span>
        </div>
      </div>
    </div>
    
    <!-- <div class="serveCon3" id="serveCon3">
      <div class="serveCon31 contentWidth" :style="'opacity:'+(Con3>=1?'1':'0')">
        <div class="serveCon31_left">
          <img src="../../assets/img/serve/sb.png" alt="">
          <div class="serveAbout">
            <span class="serveAbout_top">
              UNDER THE LINE
            </span><br>
            <span class="serveAbout_bot">
              线下
            </span>
          </div>
        </div>
        <div class="serveCon31_right">
          <span></span>
          <p>
            <span>数聚智连为品牌提供以营销驱动为导向的全方位电子商务解决方案，倡导高效整合型电商服务理念即（performance-marketing-driven E2E EC），通过高效营销（电商媒体，电商营销）和高效运营驱动品牌销售
            </span><br><br>
            <span>在电商运营服务上主要提供网络品牌定位、电商视觉、运营策划、数据服务、客户服务、会员管理、仓储物流等整体托管服务。凭借为数十家国内外知名企业/品牌提供个性化的电商服务经验，在消费电子、母婴、快速消费品/美妆、汽车等行业积累了自有服务理念。</span>
          </p>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import ZSelect from '../modules/Zselect'
export default {
  name: 'serve',
  components:{ZSelect},
  data () {
    return {
      bannerImg:[
        require('../../assets/img/serve/banner1.jpg'),
        // require('../../assets/img/serve/banner2.jpg'),
        // require('../../assets/img/serve/banner3.jpg'),
        // require('../../assets/img/serve/banner4.jpg'),
        require('../../assets/img/serve/banner5.jpg'),
      ],
      test1:'1',
      test2:'1',
      msgs: [{
        ids:1,
        value1:'我是1'
      },{
        ids:2,
        value1:'我是2'
      },{
        ids:3,
        value1:'我是3'
      },{
        ids:4,
        value1:'我是4'
      },],
      swiperOption:{
        loop:true,
        notNextTick: true,
        mousewheelControl: true,
        autoplayDisableOnInteraction:false,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        paginationClickable: true,
        autoplay : {
          delay:4000
        },
        observer:true,
        speed:1000,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
      },
      Con2Text:[
        {
          title:'2007',
          h:['北联伟业成立','博思瀚扬成立'],
        },
        {
          title:'2010',
          h:['北联伟业成为阿里第一批TP'],
        },
        {
          title:'2012',
          h:['北联伟业成为阿里TP','KA服务商'],
        },
        {
          title:'2015',
          h:['蓝标电商整合成立'],
        },
        {
          title:'2016',
          h:['挂牌新三板'],
          s:'（股票代码：300058）'
        },
        {
          title:'2018',
          h:['战略升级，更名为“北京数聚智连科技股份有限公司”，开启中国领先的品牌爆发引擎的服务理念'],
        },
      ],
      Con2:0,
      Con1:0,
      Con3:0,
      ImgHover:-1,
      con32KP1:[
        {
          title:'Oral-B星际洁齿',
          s:'第11届金投赏国际创意节金投赏奖；第25届中国国际广告节媒介营销金奖',
        },
        {
          title:'方便面3.0：方便不随便',
          s:'第11届金投赏国际创意节 金投赏奖',
        },
        {
          title:'Tampax Launch Campaign',
        },
        {
          title:'牙不白，怎么红',
          s:'第25届中国国际广告节互动创意奖',
        },
        {
          title:'Movefree天猫超级品牌日',
        },
      ],
      con32KP2:[
        {
          title:'Oral-B发现新星图',
        },
        {
          title:'放粽吧宝贝',
          s:'第25届中国国际广告节媒介营销奖',
        },
        {
          title:'iBrush Plus黑科技邀请函',
        },
        {
          title:'舒肤佳 舒服家',
          s:'艾菲奖金奖、中国广告长城奖金奖',
        },
        {
          title:'京东空气餐厅',
          s:'第25届中国国际广告节互动创意奖、媒介营销奖',
        },
      ],
      RetailD:8,
    }
  },
  methods: {
    names(data) {
      console.log(data)
    },
    // ImgMouse(data){
    //   this.ImgHover = data;
    // },
    Retail(data){
      this.RetailD = data;
    },
    RetailLe(){
      this.RetailD = 4;
    }
  },
  mounted(){
    var serveCon2 = document.getElementById('serveCon2')
    var serveCon1 = document.getElementById('serveCon1')
    var serveCon3 = document.getElementById('serveCon3')
    var serveCon2Top = 0;//距离顶部位置
    var serveCon1Top = 0;//距离顶部位置
    var serveCon3Top = 0;//距离顶部位置
    var that = this;
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
      //滚动条到底部的条件
      console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight+'元素距离顶部'+serveCon2.offsetTop);
      console.log("距顶部"+scrollHeight/windowHeight);
      if(scrollHeight/windowHeight<1.3){//如果宽高比不合适就不动画了
        that.Con1 = 6;
        that.Con2 = 6;
        that.Con3 = 4;
      }else{
        window.onscroll = function(){
          //变量scrollTop是滚动条滚动时，距离顶部的距离
          var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
          //变量windowHeight是可视区的高度
          var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
          //变量scrollHeight是滚动条的总高度
          var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
          //滚动条到底部的条件
          console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight+'元素距离顶部'+serveCon2.offsetTop);
          
          serveCon2Top = serveCon2.offsetTop-scrollTop;
          if(serveCon2Top<700 && serveCon2Top>600){
            that.Con2 = 1;
          }
          else if(serveCon2Top<=600 && serveCon2Top>500){
            that.Con2 = 2;
          }
          else if(serveCon2Top<=500 && serveCon2Top>400){
            // that.Con2 = 42.81;
            that.Con2 = 3;
          }
          else if(serveCon2Top<=400 && serveCon2Top>300){
            // that.Con2 = 42.81;
            that.Con2 = 4;
          }
          else if(serveCon2Top<=300 && serveCon2Top>200){
            // that.Con2 = 42.81;
            that.Con2 = 5;
          }
          else if(serveCon2Top<=200 && serveCon2Top>100){
            // that.Con2 = 42.81;
            that.Con2 = 6;
          }
          else if(serveCon2Top<=100){
            that.Con2 = 7;
          }
          else{
            that.Con2 = 0;
          }
          
          serveCon1Top = serveCon1.offsetTop-scrollTop;
          if(serveCon1Top<400 && serveCon1Top>300){
            that.Con1 = 1;
          }
          else if(serveCon1Top<=300 && serveCon1Top>200){
            that.Con1 = 2;
          }
          else if(serveCon1Top<=200 && serveCon1Top>100){
            that.Con1 = 3;
          }
          else if(serveCon1Top<=100 && serveCon1Top>0){
            that.Con1 = 4;
          }
          else if(serveCon1Top<=0){
            that.Con1 = 5;
          }else{
            that.Con1 = 0;
          }
          
          serveCon3Top = serveCon3.offsetTop-scrollTop;
          console.log(that.Con3);
          if(serveCon3Top<650 && serveCon3Top>450){
            that.Con3 = 1;
          }
          else if(serveCon3Top<=450 && serveCon3Top>350){
            that.Con3 = 2;
          }
          else if(serveCon3Top<=350 && serveCon3Top>250){
            that.Con3 = 3;
          }
          else if(serveCon3Top<=250){
            that.Con3 = 4;
          }
          else{
            that.Con3 = 0;
          }
        }
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less"> 
.serve{
  
  border-top: 1px solid transparent;
  // 第二屏
  .clientCon2{
    margin-top: 0 !important;
    height: 100px;
    position: relative;
    .clientAbout{
      display: inline-block;
      width: 360px;
      height: 100px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      font-size: 38px;
      color: #555;
      transition: all 1s;
      -moz-transition: all 1s;	/* Firefox 4 */
      -webkit-transition: all 1s;	/* Safari 和 Chrome */
      -o-transition: all 1s;	/* Opera */
      text-align: center;
      // opacity: 0;
      .clientAbout_top{
        display: inline-block;
        width: 100%;
        font-size: 32px;
        font-weight: 900;
      }
      .clientAbout_bot{
        display: inline-block;
        width: 100%;
        font-size: 22px;
        background: url('../../assets/img/client/down.png') no-repeat 428px;
        font-weight: 900;
      }
      .clientAbout_bot1{
        display: inline-block;
        width: 100%;
        font-size: 22px;
        background: url('../../assets/img/client/down.png') no-repeat 235px;
        font-weight: 900;
      }
      p{
        display: inline-block;
        background: #0168b7;
        width: 40px;
        height: 2px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        margin: 0 auto;
      }
    }

  }


  .ceshi{
    display: inline-block;
    width: 7rem;
    height: 3rem;
  }
  .swiperImg{
    width: 100%;
    min-width: 1200px;
  }
  // 第一屏
  .serveCon1{
    .serveCon12{
      height: 580px;
      margin-bottom: 80px;
    }
    // .serveCon12>.serveCon12To:hover .serveCon12Zhe{
    //   opacity: 1;
    // }
    .serveBotT{
      background: linear-gradient(bottom,#fff,#f0f0f0);
      background: -webkit-gradient(linear, left bottom, left top, from(#fff), to(#f0f0f0));
    }
    .serveBotB{
      background: linear-gradient(top,#fff,#fafafa);
      background: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#fafafa));
    }
    .serveBotJ{
      // background: red;
      display: inline-block;
      width: 100%;
      height: 100%;
      border-radius: red;
      position: absolute;
      top:0;
      left: 0;
      transform: scale(1.05);
      -ms-transform:scale(1.05);     /* IE 9 */
      -moz-transform:scale(1.05);     /* Firefox */
      -webkit-transform:scale(1.05); /* Safari 和 Chrome */
      -o-transform:scale(1.05);

      transition: all 0.5s;
      -moz-transition: all 0.5s;	/* Firefox 4 */
      -webkit-transition: all 0.5s;	/* Safari 和 Chrome */
      -o-transition: all 0.5s;	/* Opera */
    }
    .serveBotJD{
      transform: scale(0.85);
      -ms-transform:scale(0.85);     /* IE 9 */
      -moz-transform:scale(0.85);     /* Firefox */
      -webkit-transform:scale(0.85); /* Safari 和 Chrome */
      -o-transform:scale(0.85);
    }
    .serveBotJ span:nth-of-type(1)::after{
      content: '';
      display: inline-block;
      width: 5%;
      height: 5%;
      border-left: 2px solid rgba(0,104,183,1);
      border-top: 2px solid rgba(0,104,183,1);
      position: absolute;
      top:0;
      left: 0;
    }
    .serveBotJ span:nth-of-type(1)::before{
      content: '';
      display: inline-block;
      width: 5%;
      height: 5%;
      border-left: 2px solid rgba(0,104,183,1);
      border-bottom: 2px solid rgba(0,104,183,1);
      position: absolute;
      bottom:0;
      left: 0;
    }
    .serveBotJ span:nth-of-type(2)::after{
      content: '';
      display: inline-block;
      width: 5%;
      height: 5%;
      border-right: 2px solid rgba(0,104,183,1);
      border-top: 2px solid rgba(0,104,183,1);
      position: absolute;
      top:0;
      right: 0;
    }
    .serveBotJ span:nth-of-type(2)::before{
      content: '';
      display: inline-block;
      width: 5%;
      height: 5%;
      border-right: 2px solid rgba(0,104,183,1);
      border-bottom: 2px solid rgba(0,104,183,1);
      position: absolute;
      bottom:0;
      right: 0;
    }
    .serveCon12>.serveCon12To{
      display: inline-block;
      font-size: 0;
      overflow: hidden;
      height: 290px;
      width: 25%;
      float: left;
      position: relative;
      padding: 30px 30px;
      box-sizing: border-box;
      color: #828282;
      transition: all 0.5s;
      -moz-transition: all 0.5s;	/* Firefox 4 */
      -webkit-transition: all 0.5s;	/* Safari 和 Chrome */
      -o-transition: all 0.5s;	/* Opera */
      span{
        font-size: 12px;
        display: block;
        line-height: 24px;
      }
      h2{
        font-size: 16px;
        // border-left: 2px solid rgba(0,104,183,1 );
        position: relative;
      }
      h2::after{
        content: '';
        display: inline-block;
        background: rgba(0,104,183,1);
        width: 3px;
        height: 16px;
        position: absolute;
        left: -16px;
        top: 2px;
      }
    }
    .serveCon12::after{
      display: inline-block;
      overflow: hidden;
      clear: both;
      content: '';
    }
    .ImgBig{
      transform:scale(1.2);
      -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
      -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
    }
    .ImgMix{
      transform:scale(1);
      -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
      -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
    }
    .serveCon11{
      height: 400px;
      background: #fff;
      .serveCon11_right,.serveCon11_left{
        display: inline-block;
        height: 100%;
        width: 50%;
        float: left;
        border: none;
      }
    }
    .serveCon11::after{
      display: inline-block;
      overflow: hidden;
      clear: both;
      content: '';
    }
    .serveCon11_left{
      position: relative;
      img{
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        margin: auto;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        width: 20%;
        animation: insuran11SF 5s;
        -moz-animation: insuran11SF 5s;	/* Firefox */
        -webkit-animation: insuran11SF 5s;	/* Safari 和 Chrome */
        -o-animation: insuran11SF 5s;	/* Opera */
      }
      @keyframes insuran11SF
      {
        from {
        transform:scale(1.2);
        -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
        }
        to {
        transform:scale(1);
        -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
        }
      }

      @-moz-keyframes insuran11SF /* Firefox */
      {
        from {
        transform:scale(1.2);
        -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
        }
        to {
        transform:scale(1);
        -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
        }
      }

      @-webkit-keyframes insuran11SF /* Safari 和 Chrome */
      {
        from {
        transform:scale(1.2);
        -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
        }
        to {
        transform:scale(1);
        -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
        }
      }

      @-o-keyframes insuran11SF /* Opera */
      {
        from {
        transform:scale(1.2);
        -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
        }
        to {
        transform:scale(1);
        -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
        }
      }
      .serveAbout{
        display: inline-block;
        width: 315px;
        height: 100px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        font-size: 38px;
        color: #555;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        animation: swiperRc 3s;
        -moz-animation: swiperRc 3s;	/* Firefox */
        -webkit-animation: swiperRc 3s;	/* Safari 和 Chrome */
        -o-animation: swiperRc 3s;	/* Opera */
        .serveAbout_top{
          display: inline-block;
          width: 100%;
          font-size: 32px;
          font-weight: 900;
        }
        .serveAbout_bot{
          display: inline-block;
          width: 100%;
          font-size: 22px;
          background: url('../../assets/img/serve/right.png') no-repeat right;
          font-weight: 900;
        }
      }
    }
    .serveCon11_right{
      position: relative;
      font-size: 14px;
      line-height: 24px;
      color: #555;
      padding:100px 20px;
      box-sizing: border-box;
    }
    .serveCon11_right>span{
      position: absolute;
      left: 0;
      top: 120px;
      display: inline-block;
      background: #0168b7;
      height: 40px;
      width: 4px;
    }
    .serveCon11::after{
      content: '';
      clear: both;
    }
  }
  .swiper-container{//轮播入场
    animation: swiperRc 2s;
    -moz-animation: swiperRc 2s;	/* Firefox */
    -webkit-animation: swiperRc 2s;	/* Safari 和 Chrome */
    -o-animation: swiperRc 2s;	/* Opera */
  }
  @keyframes swiperRc
  {
    from {opacity:0;}
    to {opacity: 1;}
  }

  @-moz-keyframes swiperRc /* Firefox */
  {
    from {opacity:0;}
    to {opacity: 1;}
  }

  @-webkit-keyframes swiperRc /* Safari 和 Chrome */
  {
    from {opacity:0;}
    to {opacity: 1;}
  }

  @-o-keyframes swiperRc /* Opera */
  {
    from {opacity:0;}
    to {opacity: 1;}
  }
  //第二屏
  .serveCon2{
    height: 650px;
    // background: #f0f0f0;
    background: #fff;
    min-width: 1200px;
    transition: all 2s;
    -moz-transition: all 2s;	/* Firefox 4 */
    -webkit-transition: all 2s;	/* Safari 和 Chrome */
    -o-transition: all 2s;	/* Opera */
    padding-top: 5px;
    .serveCon21_right{
      position: relative;
      font-size: 14px;
      line-height: 24px;
      color: #555;
      padding:100px 20px;
      box-sizing: border-box;
    }
    .serveCon21_right>span{
      position: absolute;
      left: 0;
      top: 120px;
      display: inline-block;
      background: #0168b7;
      height: 40px;
      width: 4px;
    }
    .serveCon21::after{
      content: '';
      clear: both;
    }
    .serveCon21{
      height: 350px;
      opacity: 0;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
      .serveCon21_right,.serveCon21_left{
        display: inline-block;
        height: 100%;
        width: 50%;
        float: left;
        border: none;
      }
    }
    .serveCon21::after{
      display: inline-block;
      overflow: hidden;
      clear: both;
      content: '';
    }
    
    .serveCon21_left{
      position: relative;
      img{
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        margin: auto;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        width: 20%;
        animation: insuran11SF 5s;
        -moz-animation: insuran11SF 5s;	/* Firefox */
        -webkit-animation: insuran11SF 5s;	/* Safari 和 Chrome */
        -o-animation: insuran11SF 5s;	/* Opera */
      }
      @keyframes insuran11SF
      {
        from {
        transform:scale(1.2);
        -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
        }
        to {
        transform:scale(1);
        -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
        }
      }

      @-moz-keyframes insuran11SF /* Firefox */
      {
        from {
        transform:scale(1.2);
        -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
        }
        to {
        transform:scale(1);
        -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
        }
      }

      @-webkit-keyframes insuran11SF /* Safari 和 Chrome */
      {
        from {
        transform:scale(1.2);
        -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
        }
        to {
        transform:scale(1);
        -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
        }
      }

      @-o-keyframes insuran11SF /* Opera */
      {
        from {
        transform:scale(1.2);
        -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
        }
        to {
        transform:scale(1);
        -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
        }
      }
      .serveAbout{
        display: inline-block;
        width: 330px;
        height: 100px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        font-size: 38px;
        color: #555;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        animation: swiperRc 3s;
        -moz-animation: swiperRc 3s;	/* Firefox */
        -webkit-animation: swiperRc 3s;	/* Safari 和 Chrome */
        -o-animation: swiperRc 3s;	/* Opera */
        .serveAbout_top{
          display: inline-block;
          width: 100%;
          font-size: 32px;
          font-weight: 900;
        }
        .serveAbout_bot{
          display: inline-block;
          width: 100%;
          font-size: 22px;
          background: url('../../assets/img/serve/right.png') no-repeat right;
          font-weight: 900;
        }
      }
    }
    .serveCon21_right{
      position: relative;
      font-size: 14px;
      line-height: 24px;
      color: #555;
      padding:100px 20px;
      box-sizing: border-box;
    }
    .serveCon21_right>span{
      position: absolute;
      left: 0;
      top: 120px;
      display: inline-block;
      background: #0168b7;
      height: 40px;
      width: 4px;
    }
    /* for Chrome */
    .serveCon21::-webkit-scrollbar {
        display: none;
    }
    .serveCon22{
      height: 350px;
      // .serveCon22C:nth-of-type(2n){
      //   background: linear-gradient(top,#fff;#f0f0f0)
      // }
      // .serveCon22C:nth-of-type(2n+1){
      //   background: linear-gradient(bottom,#fff;#f0f0f0)
      // }
      .serveCon22C{
        display: inline-block;
        width: 33.3%;
        height: 100%;
        float: left;
        padding: 30px 60px;
        box-sizing: border-box;
        position: relative;
        z-index: 1;
        overflow: hidden;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        .server22T{
          display: inline-block;
          width: 100%;
          height: 100%;
          background: linear-gradient(bottom,#f0f0f0,rgba(255,255,255,0));
          background: -webkit-gradient(linear, left bottom, left top, from(#f0f0f0), to(rgba(255, 255, 255, 0)));
          position: absolute;
          bottom: 0;
          left: 0;
          z-index: -1;
          transition: all 1s;
          -moz-transition: all 1s;	/* Firefox 4 */
          -webkit-transition: all 1s;	/* Safari 和 Chrome */
          -o-transition: all 1s;	/* Opera */
        }
        .serveCon22C::after{
          display: inline-block;
          overflow: hidden;
          clear: both;
          content: '';
        }
        .server22B{
          display: inline-block;
          width: 100%;
          height: 100%;
          background: linear-gradient(top,#f0f0f0,rgba(255,255,255,0));
          background: -webkit-gradient(linear, left top, left bottom, from(#f0f0f0), to(rgba(255, 255, 255, 0)));
          position: absolute;
          top: 0;
          left: 0;
          z-index: -1;
          transition: all 1s;
          -moz-transition: all 1s;	/* Firefox 4 */
          -webkit-transition: all 1s;	/* Safari 和 Chrome */
          -o-transition: all 1s;	/* Opera */
        }
        span{
          font-size: 12px;
          display: block;
          line-height: 24px;
        }
        h2{
          font-size: 16px;
          // border-left: 2px solid rgba(0,104,183,1 );
          position: relative;
        }
        h2::after{
          content: '';
          display: inline-block;
          background: rgba(0,104,183,1);
          width: 3px;
          height: 16px;
          position: absolute;
          left: -16px;
          top: 2px;
        }
      }
    }
    .serveCon22:after{
      content: '';
      clear: both;
    }
  }
  // 第三屏
  .serveCon3{
    height: 400px;
    .serveCon31_right{
      position: relative;
      font-size: 14px;
      line-height: 24px;
      color: #555;
      padding:100px 20px;
      box-sizing: border-box;
    }
    .serveCon31_right>span{
      position: absolute;
      left: 0;
      top: 120px;
      display: inline-block;
      background: #0168b7;
      height: 40px;
      width: 4px;
    }
    .serveCon31::after{
      content: '';
      clear: both;
    }
    .serveCon31{
      height: 350px;
      // opacity: 0;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
      .serveCon31_right,.serveCon31_left{
        display: inline-block;
        height: 100%;
        width: 50%;
        float: left;
        border: none;
      }
    }
    .serveCon31::after{
      display: inline-block;
      overflow: hidden;
      clear: both;
      content: '';
    }
    
    .serveCon31_left{
      position: relative;
      img{
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        margin: auto;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        width: 20%;
        animation: insuran11SF 5s;
        -moz-animation: insuran11SF 5s;	/* Firefox */
        -webkit-animation: insuran11SF 5s;	/* Safari 和 Chrome */
        -o-animation: insuran11SF 5s;	/* Opera */
      }
      @keyframes insuran11SF
      {
        from {
        transform:scale(1.2);
        -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
        }
        to {
        transform:scale(1);
        -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
        }
      }

      @-moz-keyframes insuran11SF /* Firefox */
      {
        from {
        transform:scale(1.2);
        -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
        }
        to {
        transform:scale(1);
        -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
        }
      }

      @-webkit-keyframes insuran11SF /* Safari 和 Chrome */
      {
        from {
        transform:scale(1.2);
        -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
        }
        to {
        transform:scale(1);
        -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
        }
      }

      @-o-keyframes insuran11SF /* Opera */
      {
        from {
        transform:scale(1.2);
        -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
        }
        to {
        transform:scale(1);
        -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
        }
      }
      .serveAbout{
        display: inline-block;
        width: 330px;
        height: 100px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        font-size: 38px;
        color: #555;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        animation: swiperRc 3s;
        -moz-animation: swiperRc 3s;	/* Firefox */
        -webkit-animation: swiperRc 3s;	/* Safari 和 Chrome */
        -o-animation: swiperRc 3s;	/* Opera */
        .serveAbout_top{
          display: inline-block;
          width: 100%;
          font-size: 32px;
          font-weight: 900;
        }
        .serveAbout_bot{
          display: inline-block;
          width: 100%;
          font-size: 22px;
          background: url('../../assets/img/serve/right.png') no-repeat right;
          font-weight: 900;
        }
      }
    }
    .serveCon31_right{
      position: relative;
      font-size: 14px;
      line-height: 24px;
      color: #555;
      padding:100px 20px;
      box-sizing: border-box;
    }
    .serveCon31_right>span{
      position: absolute;
      left: 0;
      top: 120px;
      display: inline-block;
      background: #0168b7;
      height: 40px;
      width: 4px;
    }
    /* for Chrome */
    .serveCon31::-webkit-scrollbar {
        display: none;
    }
  }
  .ZhuanY{
    transform:rotate(0deg);
    -ms-transform:rotate(0deg); 	/* IE 9 */
    -moz-transform:rotate(0deg); 	/* Firefox */
    -webkit-transform:rotate(0deg); /* Safari 和 Chrome */
    -o-transform:rotate(0deg); 	/* Opera */
  }
  .ZhuanN{
    transform:rotate(180deg);
    -ms-transform:rotate(180deg); 	/* IE 9 */
    -moz-transform:rotate(180deg); 	/* Firefox */
    -webkit-transform:rotate(180deg); /* Safari 和 Chrome */
    -o-transform:rotate(180deg); 	/* Opera */
    }
}
</style>



// WEBPACK FOOTER //
// src/components/views/serve.vue